import { Spacing8 } from 'autogen/design-tokens/tokens';
import DefaultMenuItem from 'components/generic/menu/components/DefaultMenuItem';
import RatingStars from 'components/generic/ratingStars';
import { Typography } from 'components/generic/typography';
import Flex from 'components/Layout/components/Flex';
import Checkbox from 'components/shared/inputs/checkbox';
import useGA4Tracking from 'modules/tracking/GA4';
import useFilters from '../../../shared/hooks/useFilters';
import { HitCount } from '../shared/styles';
import type { BooleanStarFilterOption as IBooleanStarFilterOption } from '../shared/types';

export default function BooleanStarFilterOption({
    model: { displayName, hitCount, isDisabled, value },
    queryStringName,
    menuDisplayName
}: IBooleanStarFilterOption) {
    const ga4Tracking = useGA4Tracking();
    const { togglePendingFilterByValue, isPendingFilterValueActive } = useFilters();

    if (isDisabled) return null;

    const isSelected = isPendingFilterValueActive(queryStringName, value);

    const afterSlot = (
        <Flex.Row gap={Spacing8} alignItems="center">
            <HitCount forwardedAs="span" size="M">
                ({hitCount})
            </HitCount>
            <Checkbox readOnly checked={isSelected} tabIndex={-1} />
        </Flex.Row>
    );

    return (
        <DefaultMenuItem.Button
            buttonProps={{
                onClick: () => {
                    togglePendingFilterByValue(queryStringName, value);
                    ga4Tracking({
                        eventName: 'select_filter',
                        category: 'ecommerce',
                        eventParams: [
                            { param_name: 'list_name', param_value: displayName },
                            { param_name: 'filter_name', param_value: value },
                            { param_name: 'filter_list_name', param_value: menuDisplayName }
                        ]
                    });
                }
            }}
            afterSlot={afterSlot}
            beforeSlot={
                <Typography.Body as="span" size="M" strong>
                    {displayName}
                </Typography.Body>
            }
        >
            <RatingStars size="M" rating={Number(value)} />
        </DefaultMenuItem.Button>
    );
}
